import { Route, Routes } from "react-router";
import MainLayout from "../layouts/MainLayout";
import InsideIran from "../reserve Items/insideIran";
import OutsideIran from "./../reserve Items/OutsideIran";
import HotelReserve from "./../reserve Items/HotelReserve";
import TrainTicket from "./../reserve Items/TrainTicket";
import BusTicket from "./../reserve Items/BusTicket";
import { Helmet } from "react-helmet";
import PlaneTicket from "./PlaneTicket";
import MobileHome from "./mobile/Home";
import MobileLayout from "./../layouts/MobileLayout";
import { useState } from "react";
import AliGashtBlog from "./blog/Blog";

const AliGasht = () => {
  const [screenSize, setScreenSize] = useState(window.screen.width);

  window.addEventListener("resize", () => {
    setScreenSize(window.screen.width);
  });

  return (
    <>
      <Helmet>
        <title>خدمات سفرهای شما |علی گشت</title>
      </Helmet>
      {screenSize >= 900 ? (
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route path="/" element={<InsideIran />} />
            <Route path="/iranout" element={<OutsideIran />} />
            <Route path="/hotel-reservation" element={<HotelReserve />} />
            <Route path="/train-ticket" element={<TrainTicket />} />
            <Route path="/bus-ticket" element={<BusTicket />} />
          </Route>
        </Routes>
      ) : (
        <Routes>
          <Route path="/" element={<MobileLayout />}>
            <Route path="/" element={<MobileHome />} />
            <Route path="/train-ticket" element={<TrainTicket />} />
            <Route path="/bus-ticket" element={<BusTicket />} />
            <Route path="/hotel-reservation" element={<HotelReserve />} />

          </Route>
          <Route path="/plane-ticket" element={<PlaneTicket />} />
        </Routes>
      )}

      <Routes>
        <Route path="/blog" element={<AliGashtBlog/>}>

        </Route>

      </Routes>
    </>
  );
};

export default AliGasht;
